<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    :transform-data="transformData"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ editable, form }">
      {{ getTitle(editable, form) }}
    </template>

    <template #default="{ editable, form }">
      <PublicationStorageForm
        :form="form"
        :publication="publication"
        :disabled="editable"
      />
    </template>
  </BModalForm>
</template>

<script>
import { PublicationStorageModel as Model } from '../Model'

import BModalForm from '@/components/modals/BModalForm.vue'
import PublicationStorageForm, { createDefaultData } from './PublicationStorageForm.vue'


export default {
  name: 'PublicationStorageModal',
  components: {
    BModalForm,
    PublicationStorageForm,
  },
  inheritAttrs: false,
  props: {
    publication: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'start_at' in prop
        && 'end_at' in prop
        && 'participants' in prop
      ),
    },
  },
  data: (vm) => ({
    createDefaultData: () => createDefaultData(
      vm.publication.start_at,
      vm.publication.end_at,
    ),
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    getTitle(editable, form) {
      if (editable) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
    transformData(data) {
      return data
    },
  },
}
</script>
